import Utils from "./Utils";
import inscriptionService from "@/services/inscription.js";

export default {
  mixins: [Utils],
  data() {
    return {
      sendingSMSLoading: false,
      sendingSMSError: false,
      isVerifiedPhoneNumber: false,
      buttonDataIsValidated: "OK !",
      buttonDefaultData: "Valider",
      isSentConfirmationCode: false,
      fixedHeaderAlert: {},
    };
  },
  computed: {
    getVariantButtonValider() {
      return this.errors.has("numéro de téléphone")
        ? "danger"
        : this.isVerifiedPhoneNumber
        ? "success"
        : "primary";
    },
  },
  methods: {
    sendSMS(tel) {
      const vue = this;
      vue.$refs["validationSMS"].hide();
      inscriptionService
        .sendPhoneConfirmationSMS({ mobile: tel })
        .then((response) => {
          // handle success
          if (response.success) {
            localStorage.setItem("verifyPhoneCode", response.data.code);
            vue.isReadyInputSMSConfirmationCode = response.success;
            vue.fixedHeaderAlert.message = response.message;
            vue.fixedHeaderAlert.variant = response.success
              ? "success"
              : "danger";
            vue.fixedHeaderAlert.show = true;
            vue.isSentConfirmationCode = response.success;
            vue.isConfirmedCodeSuccess = false;
            vue.callToaster("Code envoyé !");
          } else {
            vue.sendingSMSError = true;
            vue.callToaster("Une erreur s'est produite.");
            console.error(response.message);
          }
        })
        .catch((error) => {
          // handle error
          console.error(error);
          vue.sendingSMSError = true;
        })
        .finally(() => {
          // always executed
          vue.sendingSMSLoading = false;
        });
    },
    confirmSMS() {
      const vue = this;
      var code = localStorage.getItem("verifyPhoneCode");
      if (code == vue.user.confirmationSMSCode) {
        vue.isConfirmedCodeSuccess = true;
        vue.isVerifiedPhoneNumber = true;
        vue.callToaster(vue.$t("successfully-verify-number"));
      } else {
        vue.isVerifiedPhoneNumber = false;
        vue.callToaster("Code incorrect !");
      }
      vue.user.confirmationSMSCode = "";
    },
  },
};
